import React, {useContext, useEffect, useRef, useState} from "react";
import AppbarActionButton from "../../../elements/buttons/AppbarActionButton";
import {Cancel, Save} from "@mui/icons-material";

import {AppbarContentContext} from "../../../routing/appbar/AppbarContentProvider";
import useEditProfile from "./useEditProfile";
import GeneralEditUserForm from "../../../../admin/sections/users/utils/GeneralEditUserForm";
import useLoadUser from "../../../../admin/sections/users/utils/useLoadUser";
import LoadingProgressIndication from "../../../elements/progress/loading/LoadingProgressIndication";
import {Box, LinearProgress} from "@mui/material";
import {useIntl} from "react-intl";

const EditProfileSection = () => {
    // Load the fresh user based on the uid from the URL parameter
    const {user, loading} = useLoadUser(null)

    // Hook to update the appbar
    const {setCurrentAppbarContent} = useContext(AppbarContentContext)

    // Hook providing the save user functionality
    const {saveUser, saveInProgress, cancel} = useEditProfile()

    // Reference, which holds will hold the user data according to the current form data (from the general user component)
    const editedUserRef = useRef()

    // Determines if the save button should be enabled.
    const [saveButtonEnabled, setSaveButtonEnabled] = useState(false)

    // Internationalization for simple strings
    const intl = useIntl();

    const getHeader = (user) => {
        if (!user) {
            return <Box width={200}/>
        }
        if (user.firstName && user.secondName) {
            return user.firstName + ' ' + user.secondName
        } else {
            return user.displayName
        }
    }

    const getDescription = (user) => {
        if (!user) {
            return <LinearProgress style={{color: "white"}}/>
        }
        return user.email
    }

    // Setting the appbar content
    useEffect(() => {
        setCurrentAppbarContent({
            header: getHeader(user),
            description: getDescription(user),
            actions: <>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.profile.edit.appbar.actions.save',
                        defaultMessage: 'Save'
                    })}
                    onClick={() => saveUser(editedUserRef.current)}
                    icon={<Save/>}
                    disabled={!saveButtonEnabled}/>
                <AppbarActionButton
                    label={intl.formatMessage({
                        id: 'app.profile.edit.appbar.actions.cancel',
                        defaultMessage: 'Cancel'
                    })}
                    onClick={() => cancel()}
                    icon={<Cancel/>}/>
            </>,
            progress: saveInProgress
        })
    }, [saveButtonEnabled, user, saveInProgress])

    if (loading) {
        return <LoadingProgressIndication text={intl.formatMessage({
            id: 'app.profile.edit.loading',
            defaultMessage: 'Loading profile...'
        })}/>
    }

    if (saveInProgress) {
        return <LoadingProgressIndication
            text={intl.formatMessage({
                id: 'app.profile.edit.save.loading',
                defaultMessage: 'Saving Profile Data...'
            })}/>
    }

    return (
        <GeneralEditUserForm selectedUser={user}
                             editedUserRef={editedUserRef}
                             setSaveButtonEnabled={setSaveButtonEnabled}/>
    );
}

export default EditProfileSection